export default {
    path: '',
    component: () => import(`@/component/admin-layout/index.vue`),
    children: [
        {
            path: '/admin/yinzhilv/demo-HotelDomesticCitySelector',
            name: 'admin-yinzhilv-demo-HotelDomesticCitySelector',
            component: () => import(`./index.vue`),
            meta: {
                entity_for_history_tag: {
                    name: `demo-HotelDomesticCitySelector`,
                },
                entity_list_for_breadcrumb: [
                    {name: `demo`},
                    {name: `demo-HotelDomesticCitySelector`},
                ],
            },
        },
    ],
};
